var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: { fullSize: _vm.loading } },
    [
      _c(
        "v-row",
        {
          staticClass: "mx-0",
          class: { fullSize: _vm.loading },
          attrs: { "align-center": "", "justify-center": "" },
        },
        [
          _c(
            "v-col",
            {
              key: _vm.pageKey,
              staticClass: "pa-0 generalClass-table-padding",
              attrs: { cols: "12" },
            },
            [
              _vm.loading
                ? _c("loading-page")
                : _vm.appInstancesError.error ||
                  !_vm.getApplicationInstances.length
                ? _c("default-page", {
                    attrs: {
                      imageUrl: "/img/dynamic-src-images/applications.svg",
                      title: "Applications",
                      text: _vm.pageText,
                      errorMessage: _vm.appInstancesError.error
                        ? _vm.appInstancesError.details.message
                        : "",
                      buttonText: _vm.appInstancesError.error
                        ? "Reload"
                        : "Get Started",
                    },
                    on: { "button-clicked": _vm.buttonClicked },
                  })
                : _c(
                    "div",
                    [
                      _c(
                        "v-row",
                        { attrs: { "no-gutters": "" } },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("v-data-table", {
                                staticClass: "main_page_table",
                                class: {
                                  "empty-data-table":
                                    !_vm.getApplicationInstances.length,
                                },
                                attrs: {
                                  "mobile-breakpoint": 0,
                                  height: `${
                                    _vm.$vuetify.breakpoint.mdAndUp
                                      ? _vm.windowSizeY - 100
                                      : _vm.windowSizeY - 96
                                  }px`,
                                  "items-per-page": _vm.itemsPerPage,
                                  page: _vm.page,
                                  "fixed-header": "",
                                  "custom-sort": _vm.currentSortingAlgo,
                                  headers: _vm.headers,
                                  items: _vm.getApplicationInstancesAndIndexes,
                                  expanded: _vm.expanded,
                                  dense: "",
                                  "hide-default-header": "",
                                  "hide-default-footer": "",
                                  "sort-by": "version",
                                  "item-key": "id",
                                  "single-expand": "",
                                },
                                on: {
                                  "update:page": function ($event) {
                                    _vm.page = $event
                                  },
                                  "page-count": function ($event) {
                                    _vm.pageCount = $event
                                  },
                                  "update:expanded": function ($event) {
                                    _vm.expanded = $event
                                  },
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "header",
                                    fn: function ({ props: { headers } }) {
                                      return [
                                        _c("thead", [
                                          _c(
                                            "tr",
                                            _vm._l(
                                              _vm.headersCounter,
                                              function (header, index) {
                                                return _c(
                                                  "th",
                                                  {
                                                    key: index,
                                                    staticClass:
                                                      "allTableHeaders",
                                                    style:
                                                      headers[index].value ===
                                                        "action" &&
                                                      _vm.addButtonOverLaps
                                                        ? "width: 248px;"
                                                        : "opacity:1;",
                                                  },
                                                  [
                                                    _c(
                                                      "v-row",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                          justify: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "v-col",
                                                          {
                                                            attrs: {
                                                              height: "100%",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-row",
                                                              {
                                                                class:
                                                                  headers[index]
                                                                    .value ===
                                                                  "action"
                                                                    ? "pl-0"
                                                                    : "pl-3",
                                                                style:
                                                                  headers[index]
                                                                    .value ===
                                                                    "action" ||
                                                                  _vm.headersCounter ===
                                                                    1
                                                                    ? "justify-content: center;"
                                                                    : "",
                                                              },
                                                              [
                                                                _c("v-hover", {
                                                                  scopedSlots:
                                                                    _vm._u(
                                                                      [
                                                                        {
                                                                          key: "default",
                                                                          fn: function ({
                                                                            hover,
                                                                          }) {
                                                                            return [
                                                                              _c(
                                                                                "p",
                                                                                {
                                                                                  staticClass:
                                                                                    "my-0 fullHeight",
                                                                                  class:
                                                                                    headers[
                                                                                      index
                                                                                    ]
                                                                                      .value ===
                                                                                    "action"
                                                                                      ? "text-center"
                                                                                      : "allTableHeadersHover",
                                                                                  on: {
                                                                                    click:
                                                                                      function (
                                                                                        $event
                                                                                      ) {
                                                                                        _vm.currentSortingAlgo =
                                                                                          _vm.getNewSortingAlgo(
                                                                                            headers[
                                                                                              index
                                                                                            ]
                                                                                          )
                                                                                        _vm.selectedHeader =
                                                                                          headers[
                                                                                            index
                                                                                          ].value
                                                                                      },
                                                                                  },
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    " " +
                                                                                      _vm._s(
                                                                                        headers[
                                                                                          index
                                                                                        ]
                                                                                          .text
                                                                                      ) +
                                                                                      " "
                                                                                  ),
                                                                                  _c(
                                                                                    "v-icon",
                                                                                    {
                                                                                      directives:
                                                                                        [
                                                                                          {
                                                                                            name: "show",
                                                                                            rawName:
                                                                                              "v-show",
                                                                                            value:
                                                                                              headers[
                                                                                                index
                                                                                              ]
                                                                                                .value !==
                                                                                              "action",
                                                                                            expression:
                                                                                              "headers[index].value !== 'action'",
                                                                                          },
                                                                                        ],
                                                                                      staticStyle:
                                                                                        {
                                                                                          "font-size":
                                                                                            "12px",
                                                                                          "margin-left":
                                                                                            "-3px",
                                                                                        },
                                                                                      style:
                                                                                        hover ||
                                                                                        _vm.selectedHeader ===
                                                                                          headers[
                                                                                            index
                                                                                          ]
                                                                                            .value
                                                                                          ? "transition: opacity 0.1s;opacity: 1; cursor: pointer;color: white !important;"
                                                                                          : "opacity: 0.2;",
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        " " +
                                                                                          _vm._s(
                                                                                            _vm.getSortingIcon(
                                                                                              headers[
                                                                                                index
                                                                                              ]
                                                                                                .currentSortAlg
                                                                                            )
                                                                                          ) +
                                                                                          " "
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ],
                                                                                1
                                                                              ),
                                                                            ]
                                                                          },
                                                                        },
                                                                      ],
                                                                      null,
                                                                      true
                                                                    ),
                                                                }),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                        ]),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item",
                                    fn: function ({ item, index }) {
                                      return [
                                        _c(
                                          "tr",
                                          {
                                            staticClass: "rowClick",
                                            attrs: {
                                              id: _vm.$vuetify.theme.dark
                                                ? "dataTableRow_dark"
                                                : "dataTableRow_light",
                                            },
                                            on: {
                                              click: function ($event) {
                                                _vm.headersCounter !==
                                                _vm.headers.length
                                                  ? _vm.expandRow(item)
                                                  : ""
                                              },
                                            },
                                          },
                                          [
                                            _vm._l(
                                              _vm.headersCounter ===
                                                _vm.headers.length
                                                ? _vm.headersCounter - 1
                                                : _vm.headersCounter,
                                              function (head, index) {
                                                return _c(
                                                  "td",
                                                  {
                                                    key: index,
                                                    class: _vm.$vuetify
                                                      .breakpoint.mdAndUp
                                                      ? "table_Row pl-3"
                                                      : "table_Row pl-2",
                                                  },
                                                  [
                                                    _vm.headersCounter === 1
                                                      ? _c(
                                                          "v-row",
                                                          {
                                                            attrs: {
                                                              justify: "center",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-col",
                                                              {
                                                                staticClass:
                                                                  "pa-0",
                                                                class:
                                                                  _vm.getCellClass(
                                                                    item[
                                                                      _vm
                                                                        .headers[
                                                                        index
                                                                      ].value
                                                                    ],
                                                                    _vm.headers[
                                                                      index
                                                                    ].value
                                                                  ),
                                                                attrs: {
                                                                  cols:
                                                                    _vm.headersCounter ===
                                                                    1
                                                                      ? 8
                                                                      : 12,
                                                                },
                                                              },
                                                              [
                                                                _vm.headers[
                                                                  index
                                                                ].value ===
                                                                  "name" &&
                                                                _vm.headersCounter !==
                                                                  _vm.headers
                                                                    .length
                                                                  ? _c(
                                                                      "v-icon",
                                                                      {
                                                                        class:
                                                                          _vm.expanded.some(
                                                                            (
                                                                              el
                                                                            ) =>
                                                                              el.id ===
                                                                              item.id
                                                                          )
                                                                            ? "red--text pr-2"
                                                                            : "primary--text pr-2",
                                                                        staticStyle:
                                                                          {
                                                                            "font-size":
                                                                              "16px",
                                                                            "margin-bottom":
                                                                              "4px !important",
                                                                          },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm.expanded.some(
                                                                                (
                                                                                  el
                                                                                ) =>
                                                                                  el.id ===
                                                                                  item.id
                                                                              )
                                                                                ? "fas fa-times-circle"
                                                                                : "fas fa-chevron-circle-down"
                                                                            ) +
                                                                            " "
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                                _c(
                                                                  "p",
                                                                  {
                                                                    staticClass:
                                                                      "d-inline",
                                                                    class: `${_vm.getCellClass(
                                                                      item[
                                                                        _vm
                                                                          .headers[
                                                                          index +
                                                                            1
                                                                        ].value
                                                                      ],
                                                                      "appStatus"
                                                                    )} pa-0`,
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          item[
                                                                            _vm
                                                                              .headers[
                                                                              index
                                                                            ]
                                                                              .value
                                                                          ]
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        )
                                                      : _vm.headers[index]
                                                          .value === "name"
                                                      ? _c(
                                                          "v-tooltip",
                                                          {
                                                            attrs: {
                                                              disabled:
                                                                !_vm.isAdmin ||
                                                                _vm.isNotDesktop,
                                                              bottom: "",
                                                              "nudge-left":
                                                                "100",
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "activator",
                                                                  fn: function ({
                                                                    on,
                                                                  }) {
                                                                    return [
                                                                      _c(
                                                                        "div",
                                                                        _vm._g(
                                                                          {
                                                                            staticClass:
                                                                              "ml-3",
                                                                            class:
                                                                              _vm.getCellClass(
                                                                                item[
                                                                                  _vm
                                                                                    .headers[
                                                                                    index
                                                                                  ]
                                                                                    .value
                                                                                ],
                                                                                _vm
                                                                                  .headers[
                                                                                  index
                                                                                ]
                                                                                  .value
                                                                              ),
                                                                            style:
                                                                              _vm
                                                                                .$vuetify
                                                                                .breakpoint
                                                                                .width >
                                                                              900
                                                                                ? "margin-right:-100px;"
                                                                                : "",
                                                                          },
                                                                          on
                                                                        ),
                                                                        [
                                                                          _vm
                                                                            .headers[
                                                                            index
                                                                          ]
                                                                            .value ===
                                                                            "name" &&
                                                                          _vm.headersCounter !==
                                                                            _vm
                                                                              .headers
                                                                              .length
                                                                            ? _c(
                                                                                "v-icon",
                                                                                {
                                                                                  class:
                                                                                    _vm.expanded.some(
                                                                                      (
                                                                                        el
                                                                                      ) =>
                                                                                        el.id ===
                                                                                        item.id
                                                                                    )
                                                                                      ? "red--text pr-1"
                                                                                      : "primary--text pr-1",
                                                                                  staticStyle:
                                                                                    {
                                                                                      "font-size":
                                                                                        "16px",
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    " " +
                                                                                      _vm._s(
                                                                                        _vm.expanded.some(
                                                                                          (
                                                                                            el
                                                                                          ) =>
                                                                                            el.id ===
                                                                                            item.id
                                                                                        )
                                                                                          ? "fas fa-times-circle"
                                                                                          : "fas fa-chevron-circle-down"
                                                                                      ) +
                                                                                      " "
                                                                                  ),
                                                                                ]
                                                                              )
                                                                            : _vm._e(),
                                                                          _vm._v(
                                                                            " " +
                                                                              _vm._s(
                                                                                item[
                                                                                  _vm
                                                                                    .headers[
                                                                                    index
                                                                                  ]
                                                                                    .value
                                                                                ]
                                                                              ) +
                                                                              " "
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ]
                                                                  },
                                                                },
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                          },
                                                          [
                                                            _c("span", [
                                                              item.id
                                                                ? _c("div", [
                                                                    _vm._v(
                                                                      "ID: " +
                                                                        _vm._s(
                                                                          item.id
                                                                        )
                                                                    ),
                                                                  ])
                                                                : _vm._e(),
                                                              item.lastMessage
                                                                ? _c(
                                                                    "div",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          "max-width":
                                                                            "250px",
                                                                        },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " Last Message: " +
                                                                          _vm._s(
                                                                            item.lastMessage
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                            ]),
                                                          ]
                                                        )
                                                      : _c(
                                                          "div",
                                                          {
                                                            staticClass: "ml-3",
                                                            class:
                                                              _vm.getCellClass(
                                                                item[
                                                                  _vm.headers[
                                                                    index
                                                                  ].value
                                                                ],
                                                                _vm.headers[
                                                                  index
                                                                ].value
                                                              ),
                                                            style:
                                                              _vm.$vuetify
                                                                .breakpoint
                                                                .width > 900
                                                                ? "margin-right:-100px;"
                                                                : "",
                                                          },
                                                          [
                                                            _vm.headers[index]
                                                              .value ===
                                                              "name" &&
                                                            _vm.headersCounter !==
                                                              _vm.headers.length
                                                              ? _c(
                                                                  "v-icon",
                                                                  {
                                                                    class:
                                                                      _vm.expanded.some(
                                                                        (el) =>
                                                                          el.id ===
                                                                          item.id
                                                                      )
                                                                        ? "red--text pr-1"
                                                                        : "primary--text pr-1",
                                                                    staticStyle:
                                                                      {
                                                                        "font-size":
                                                                          "16px",
                                                                      },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          _vm.expanded.some(
                                                                            (
                                                                              el
                                                                            ) =>
                                                                              el.id ===
                                                                              item.id
                                                                          )
                                                                            ? "fas fa-times-circle"
                                                                            : "fas fa-chevron-circle-down"
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  item[
                                                                    _vm.headers[
                                                                      index
                                                                    ].value
                                                                  ]
                                                                ) +
                                                                " "
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            _vm.headersCounter ===
                                            _vm.headers.length
                                              ? _c(
                                                  "td",
                                                  {
                                                    staticClass: "text-center",
                                                  },
                                                  [
                                                    _c(
                                                      "v-btn",
                                                      {
                                                        attrs: {
                                                          id: `run-instance${index}`,
                                                          disabled: !_vm
                                                            .checkStatus()
                                                            .isRunAllowed(
                                                              item.appStatus
                                                            ),
                                                          loading:
                                                            _vm.playButtonLoading &&
                                                            _vm
                                                              .checkStatus()
                                                              .isRunAllowed(
                                                                item.appStatus
                                                              ) &&
                                                            _vm.loadingIds.some(
                                                              (lid) =>
                                                                lid === item.id
                                                            ),
                                                          icon: "",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "icon-play-21x21",
                                                            staticStyle: {
                                                              "font-size":
                                                                "28px",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                _vm.playButtonLoading = true
                                                                _vm.loadingIds.push(
                                                                  item.id
                                                                )
                                                                _vm.handleAction(
                                                                  item.id,
                                                                  item.appStatus ===
                                                                    "SUSPENDED"
                                                                    ? _vm
                                                                        .ACTIONS
                                                                        .RESUME
                                                                    : _vm
                                                                        .ACTIONS
                                                                        .START
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c("span", {
                                                              class: !_vm
                                                                .checkStatus()
                                                                .isRunAllowed(
                                                                  item.appStatus
                                                                )
                                                                ? "path1Disabled letterSpacing0"
                                                                : "path1 letterSpacing0",
                                                            }),
                                                            _c("span", {
                                                              staticClass:
                                                                "path2",
                                                            }),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "v-tooltip",
                                                      {
                                                        attrs: {
                                                          disabled: !_vm
                                                            .checkStatus()
                                                            .isRunAllowed(
                                                              item.appStatus
                                                            ),
                                                          activator: `#run-instance${index}`,
                                                          bottom: "",
                                                        },
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v("Run"),
                                                        ]),
                                                      ]
                                                    ),
                                                    _c(
                                                      "v-btn",
                                                      {
                                                        attrs: {
                                                          id: `terminate-instance${index}`,
                                                          icon: "",
                                                          disabled:
                                                            item.appStatus ===
                                                            "TERMINATED",
                                                          loading:
                                                            _vm.terminateButtonLoading &&
                                                            _vm
                                                              .checkStatus()
                                                              .isTerminateAllowed(
                                                                item.appStatus
                                                              ) &&
                                                            _vm.loadingIds.some(
                                                              (lid) =>
                                                                lid === item.id
                                                            ),
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "icon-stop-21x21",
                                                            staticStyle: {
                                                              "font-size":
                                                                "28px",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                _vm.terminateButtonLoading = true
                                                                _vm.loadingIds.push(
                                                                  item.id
                                                                )
                                                                _vm.terminateApplication(
                                                                  item.id
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c("span", {
                                                              staticClass:
                                                                "path1",
                                                              class:
                                                                item.appStatus ===
                                                                "TERMINATED"
                                                                  ? "path1Disabled letterSpacing0"
                                                                  : "path1 letterSpacing0",
                                                            }),
                                                            _c("span", {
                                                              staticClass:
                                                                "path2",
                                                            }),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "v-tooltip",
                                                      {
                                                        attrs: {
                                                          activator: `#terminate-instance${index}`,
                                                          bottom: "",
                                                        },
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v("Terminate"),
                                                        ]),
                                                      ]
                                                    ),
                                                    _vm.isAdmin
                                                      ? _c(
                                                          "v-btn",
                                                          {
                                                            attrs: {
                                                              id: `moremenu-instance${index}`,
                                                              icon: "",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                _vm.pinging =
                                                                  _vm.PING_STATUS.DEFAULT
                                                                _vm.actionsMenuCurrentID =
                                                                  item.id
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "icon-more-21x21 letterSpacing0",
                                                                staticStyle: {
                                                                  "font-size":
                                                                    "28px",
                                                                  "margin-right":
                                                                    "2px",
                                                                },
                                                              },
                                                              [
                                                                _c("span", {
                                                                  staticClass:
                                                                    "path1 letterSpacing0",
                                                                }),
                                                                _c("span", {
                                                                  staticClass:
                                                                    "path2 letterSpacing0",
                                                                }),
                                                                _c("span", {
                                                                  staticClass:
                                                                    "path3 letterSpacing0",
                                                                }),
                                                                _c("span", {
                                                                  staticClass:
                                                                    "path4 letterSpacing0",
                                                                }),
                                                              ]
                                                            ),
                                                          ]
                                                        )
                                                      : _c(
                                                          "v-tooltip",
                                                          {
                                                            attrs: {
                                                              bottom: "",
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "activator",
                                                                  fn: function ({
                                                                    on,
                                                                  }) {
                                                                    return [
                                                                      _c(
                                                                        "v-btn",
                                                                        _vm._g(
                                                                          {
                                                                            staticClass:
                                                                              "primary ml-1",
                                                                            attrs:
                                                                              {
                                                                                rounded:
                                                                                  "",
                                                                                icon: "",
                                                                                text: "",
                                                                                dark: "",
                                                                                width:
                                                                                  "28",
                                                                                height:
                                                                                  "28",
                                                                              },
                                                                            on: {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.handleAction(
                                                                                    item.id,
                                                                                    "configure",
                                                                                    item.name
                                                                                  )
                                                                                },
                                                                            },
                                                                          },
                                                                          on
                                                                        ),
                                                                        [
                                                                          _c(
                                                                            "v-icon",
                                                                            {
                                                                              staticStyle:
                                                                                {
                                                                                  "font-size":
                                                                                    "14px",
                                                                                },
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "fas fa-cogs"
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ]
                                                                  },
                                                                },
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                "Configurations"
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                    _c(
                                                      "v-menu",
                                                      {
                                                        staticStyle: {
                                                          "margin-top": "12px",
                                                        },
                                                        attrs: {
                                                          "close-on-content-click": true,
                                                          "v-model":
                                                            _vm.actionsPanel &&
                                                            item.id ===
                                                              _vm.actionsMenuCurrentID,
                                                          bottom: "",
                                                          right: "",
                                                          activator: `#moremenu-instance${index}`,
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "v-list",
                                                          {
                                                            attrs: {
                                                              dense: "",
                                                            },
                                                          },
                                                          [
                                                            _vm._l(
                                                              _vm.items,
                                                              function (
                                                                listItem
                                                              ) {
                                                                return [
                                                                  _c(
                                                                    "v-list-item",
                                                                    {
                                                                      key: listItem.title,
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.handleAction(
                                                                              item.id,
                                                                              listItem.action,
                                                                              item.name
                                                                            )
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-list-item-action",
                                                                        {
                                                                          staticClass:
                                                                            "mr-3",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "v-icon",
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  small:
                                                                                    "",
                                                                                },
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  listItem.icon
                                                                                )
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                      _c(
                                                                        "v-list-item-content",
                                                                        [
                                                                          _c(
                                                                            "v-list-item-title",
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  listItem.title
                                                                                ) +
                                                                                  " "
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                      listItem.title ===
                                                                      "ping"
                                                                        ? _c(
                                                                            "v-list-item-action",
                                                                            {
                                                                              staticClass:
                                                                                "mr-3",
                                                                            },
                                                                            [
                                                                              _vm.pinging ===
                                                                              _vm
                                                                                .PING_STATUS
                                                                                .ACTIVE
                                                                                ? _c(
                                                                                    "v-progress-circular",
                                                                                    {
                                                                                      attrs:
                                                                                        {
                                                                                          indeterminate:
                                                                                            "",
                                                                                          color:
                                                                                            "primary",
                                                                                          width:
                                                                                            "3",
                                                                                          size: "18",
                                                                                        },
                                                                                    }
                                                                                  )
                                                                                : _vm.pinging ===
                                                                                  _vm
                                                                                    .PING_STATUS
                                                                                    .DONE
                                                                                ? _c(
                                                                                    "v-icon",
                                                                                    {
                                                                                      attrs:
                                                                                        {
                                                                                          small:
                                                                                            "",
                                                                                          color:
                                                                                            "primary",
                                                                                        },
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        "fas fa-check "
                                                                                      ),
                                                                                    ]
                                                                                  )
                                                                                : _vm.pinging ===
                                                                                  _vm
                                                                                    .PING_STATUS
                                                                                    .REJECTED
                                                                                ? _c(
                                                                                    "v-icon",
                                                                                    {
                                                                                      attrs:
                                                                                        {
                                                                                          small:
                                                                                            "",
                                                                                          color:
                                                                                            "red",
                                                                                        },
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        "fas fa-exclamation-circle "
                                                                                      ),
                                                                                    ]
                                                                                  )
                                                                                : _vm._e(),
                                                                            ],
                                                                            1
                                                                          )
                                                                        : _vm._e(),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ]
                                                              }
                                                            ),
                                                          ],
                                                          2
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ],
                                          2
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "expanded-item",
                                    fn: function ({ item }) {
                                      return _vm._l(
                                        _vm.headers.length - _vm.headersCounter,
                                        function (head, index) {
                                          return _c(
                                            "tr",
                                            {
                                              key: index,
                                              staticClass: "expandBackground",
                                            },
                                            [
                                              _c(
                                                "v-row",
                                                {
                                                  staticClass:
                                                    "expandRowClass_Border mx-0",
                                                  staticStyle: {
                                                    height: "32px",
                                                  },
                                                  attrs: {
                                                    justify: "space-around",
                                                  },
                                                },
                                                [
                                                  _vm.$vuetify.breakpoint
                                                    .width < 411
                                                    ? _c("v-col", {
                                                        attrs: { cols: "1" },
                                                      })
                                                    : _vm._e(),
                                                  _c(
                                                    "v-col",
                                                    {
                                                      staticClass:
                                                        "py-0 pl-2pr-0",
                                                      attrs: { cols: "3" },
                                                    },
                                                    [
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "ml-1 my-1",
                                                          staticStyle: {
                                                            "font-weight":
                                                              "600",
                                                            "font-size": "14px",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.headers[
                                                                  _vm.headersCounter +
                                                                    index
                                                                ].text
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "v-col",
                                                    {
                                                      staticClass:
                                                        "py-0 pl-4 pr-1",
                                                      attrs: { cols: "8" },
                                                    },
                                                    [
                                                      _vm.headers[
                                                        _vm.headersCounter +
                                                          index
                                                      ].value !== "action"
                                                        ? _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "ml-1 my-1 text-center",
                                                              class:
                                                                _vm.getCellClass(
                                                                  item[
                                                                    _vm.headers[
                                                                      _vm.headersCounter +
                                                                        index
                                                                    ].value
                                                                  ],
                                                                  _vm.headers[
                                                                    _vm.headersCounter +
                                                                      index
                                                                  ].value
                                                                ),
                                                              staticStyle: {
                                                                "font-size":
                                                                  "14px",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    item[
                                                                      _vm
                                                                        .headers[
                                                                        _vm.headersCounter +
                                                                          index
                                                                      ].value
                                                                    ]
                                                                  ) +
                                                                  " " +
                                                                  _vm._s(
                                                                    _vm.headers[
                                                                      _vm.headersCounter +
                                                                        index
                                                                    ].value ===
                                                                      "name"
                                                                      ? `(${item.identity.substring(
                                                                          0,
                                                                          2
                                                                        )})`
                                                                      : _vm
                                                                          .headers[
                                                                          _vm.headersCounter +
                                                                            index
                                                                        ]
                                                                          .value ===
                                                                        "action"
                                                                      ? ""
                                                                      : ""
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          )
                                                        : _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "text-center",
                                                            },
                                                            [
                                                              _c(
                                                                "v-tooltip",
                                                                {
                                                                  attrs: {
                                                                    bottom: "",
                                                                  },
                                                                  scopedSlots:
                                                                    _vm._u(
                                                                      [
                                                                        {
                                                                          key: "activator",
                                                                          fn: function ({
                                                                            on,
                                                                          }) {
                                                                            return [
                                                                              _c(
                                                                                "v-btn",
                                                                                _vm._g(
                                                                                  {
                                                                                    attrs:
                                                                                      {
                                                                                        height:
                                                                                          "32",
                                                                                        width:
                                                                                          "32",
                                                                                        disabled:
                                                                                          !_vm
                                                                                            .checkStatus()
                                                                                            .isRunAllowed(
                                                                                              item.appStatus
                                                                                            ),
                                                                                        loading:
                                                                                          _vm.playButtonLoading &&
                                                                                          _vm
                                                                                            .checkStatus()
                                                                                            .isRunAllowed(
                                                                                              item.appStatus
                                                                                            ) &&
                                                                                          _vm.loadingIds.some(
                                                                                            (
                                                                                              lid
                                                                                            ) =>
                                                                                              lid ===
                                                                                              item.id
                                                                                          ),
                                                                                        icon: "",
                                                                                      },
                                                                                  },
                                                                                  _vm.isNotDesktop
                                                                                    ? 0
                                                                                    : on
                                                                                ),
                                                                                [
                                                                                  _c(
                                                                                    "span",
                                                                                    {
                                                                                      staticClass:
                                                                                        "icon-play-21x21",
                                                                                      staticStyle:
                                                                                        {
                                                                                          "font-size":
                                                                                            "28px",
                                                                                        },
                                                                                      on: {
                                                                                        click:
                                                                                          function (
                                                                                            $event
                                                                                          ) {
                                                                                            _vm.playButtonLoading = true
                                                                                            _vm.loadingIds.push(
                                                                                              item.id
                                                                                            )
                                                                                            _vm.handleAction(
                                                                                              item.id,
                                                                                              item.appStatus ===
                                                                                                "SUSPENDED"
                                                                                                ? _vm
                                                                                                    .ACTIONS
                                                                                                    .RESUME
                                                                                                : _vm
                                                                                                    .ACTIONS
                                                                                                    .START
                                                                                            )
                                                                                          },
                                                                                      },
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "span",
                                                                                        {
                                                                                          class:
                                                                                            !_vm
                                                                                              .checkStatus()
                                                                                              .isRunAllowed(
                                                                                                item.appStatus
                                                                                              )
                                                                                              ? "path1Disabled letterSpacing0"
                                                                                              : "path1 letterSpacing0",
                                                                                        }
                                                                                      ),
                                                                                      _c(
                                                                                        "span",
                                                                                        {
                                                                                          staticClass:
                                                                                            "path2",
                                                                                        }
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ]
                                                                          },
                                                                        },
                                                                      ],
                                                                      null,
                                                                      true
                                                                    ),
                                                                },
                                                                [
                                                                  _c("span", [
                                                                    _vm._v(
                                                                      "Run"
                                                                    ),
                                                                  ]),
                                                                ]
                                                              ),
                                                              _vm.isAdmin
                                                                ? _c(
                                                                    "v-tooltip",
                                                                    {
                                                                      attrs: {
                                                                        bottom:
                                                                          "",
                                                                      },
                                                                      scopedSlots:
                                                                        _vm._u(
                                                                          [
                                                                            {
                                                                              key: "activator",
                                                                              fn: function ({
                                                                                on,
                                                                              }) {
                                                                                return [
                                                                                  _c(
                                                                                    "v-btn",
                                                                                    {
                                                                                      attrs:
                                                                                        {
                                                                                          height:
                                                                                            "32",
                                                                                          width:
                                                                                            "32",
                                                                                          icon: "",
                                                                                          disabled:
                                                                                            _vm
                                                                                              .checkStatus()
                                                                                              .isRunAllowed(
                                                                                                item.appStatus
                                                                                              ) ||
                                                                                            item.appStatus ===
                                                                                              "TERMINATED",
                                                                                        },
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "span",
                                                                                        _vm._g(
                                                                                          {
                                                                                            staticClass:
                                                                                              "icon-pause-21x21",
                                                                                            staticStyle:
                                                                                              {
                                                                                                "font-size":
                                                                                                  "28px",
                                                                                              },
                                                                                            on: {
                                                                                              click:
                                                                                                function (
                                                                                                  $event
                                                                                                ) {
                                                                                                  _vm.playButtonLoading = false
                                                                                                  _vm.handleAction(
                                                                                                    item.id,
                                                                                                    _vm
                                                                                                      .ACTIONS
                                                                                                      .SUSPEND
                                                                                                  )
                                                                                                },
                                                                                            },
                                                                                          },
                                                                                          _vm.isNotDesktop
                                                                                            ? 0
                                                                                            : on
                                                                                        ),
                                                                                        [
                                                                                          _c(
                                                                                            "span",
                                                                                            {
                                                                                              class:
                                                                                                _vm
                                                                                                  .checkStatus()
                                                                                                  .isRunAllowed(
                                                                                                    item.appStatus
                                                                                                  ) ||
                                                                                                item.appStatus ===
                                                                                                  "TERMINATED"
                                                                                                  ? "path1Disabled letterSpacing0"
                                                                                                  : "path1 letterSpacing0",
                                                                                            }
                                                                                          ),
                                                                                          _c(
                                                                                            "span",
                                                                                            {
                                                                                              staticClass:
                                                                                                "path3 letterSpacing0",
                                                                                            }
                                                                                          ),
                                                                                          _c(
                                                                                            "span",
                                                                                            {
                                                                                              staticClass:
                                                                                                "path2",
                                                                                            }
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ]
                                                                              },
                                                                            },
                                                                          ],
                                                                          null,
                                                                          true
                                                                        ),
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            "Suspend"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                              _c(
                                                                "v-tooltip",
                                                                {
                                                                  attrs: {
                                                                    bottom: "",
                                                                  },
                                                                  scopedSlots:
                                                                    _vm._u(
                                                                      [
                                                                        {
                                                                          key: "activator",
                                                                          fn: function ({
                                                                            on,
                                                                          }) {
                                                                            return [
                                                                              _c(
                                                                                "v-btn",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      height:
                                                                                        "32",
                                                                                      width:
                                                                                        "32",
                                                                                      icon: "",
                                                                                      disabled:
                                                                                        item.appStatus ===
                                                                                        "TERMINATED",
                                                                                      loading:
                                                                                        _vm.terminateButtonLoading &&
                                                                                        _vm
                                                                                          .checkStatus()
                                                                                          .isTerminateAllowed(
                                                                                            item.appStatus
                                                                                          ) &&
                                                                                        _vm.loadingIds.some(
                                                                                          (
                                                                                            lid
                                                                                          ) =>
                                                                                            lid ===
                                                                                            item.id
                                                                                        ),
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "span",
                                                                                    _vm._g(
                                                                                      {
                                                                                        staticClass:
                                                                                          "icon-stop-21x21",
                                                                                        staticStyle:
                                                                                          {
                                                                                            "font-size":
                                                                                              "28px",
                                                                                          },
                                                                                        on: {
                                                                                          click:
                                                                                            function (
                                                                                              $event
                                                                                            ) {
                                                                                              return _vm.terminateApplication(
                                                                                                item.id
                                                                                              )
                                                                                            },
                                                                                        },
                                                                                      },
                                                                                      _vm.isNotDesktop
                                                                                        ? 0
                                                                                        : on
                                                                                    ),
                                                                                    [
                                                                                      _c(
                                                                                        "span",
                                                                                        {
                                                                                          staticClass:
                                                                                            "path1",
                                                                                          class:
                                                                                            item.appStatus ===
                                                                                            "TERMINATED"
                                                                                              ? "path1Disabled letterSpacing0"
                                                                                              : "path1 letterSpacing0",
                                                                                        }
                                                                                      ),
                                                                                      _c(
                                                                                        "span",
                                                                                        {
                                                                                          staticClass:
                                                                                            "path2",
                                                                                        }
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ]
                                                                          },
                                                                        },
                                                                      ],
                                                                      null,
                                                                      true
                                                                    ),
                                                                },
                                                                [
                                                                  _c("span", [
                                                                    _vm._v(
                                                                      "Terminate"
                                                                    ),
                                                                  ]),
                                                                ]
                                                              ),
                                                              _c(
                                                                "v-menu",
                                                                {
                                                                  staticStyle: {
                                                                    "margin-top":
                                                                      "12px",
                                                                  },
                                                                  attrs: {
                                                                    bottom: "",
                                                                    right: "",
                                                                  },
                                                                  scopedSlots:
                                                                    _vm._u(
                                                                      [
                                                                        {
                                                                          key: "activator",
                                                                          fn: function ({
                                                                            on,
                                                                          }) {
                                                                            return [
                                                                              _c(
                                                                                "v-btn",
                                                                                _vm._g(
                                                                                  {
                                                                                    attrs:
                                                                                      {
                                                                                        height:
                                                                                          "32",
                                                                                        width:
                                                                                          "32",
                                                                                        icon: "",
                                                                                      },
                                                                                  },
                                                                                  on
                                                                                ),
                                                                                [
                                                                                  _c(
                                                                                    "span",
                                                                                    {
                                                                                      staticClass:
                                                                                        "icon-more-21x21 letterSpacing0",
                                                                                      staticStyle:
                                                                                        {
                                                                                          "font-size":
                                                                                            "28px",
                                                                                          "margin-right":
                                                                                            "2px",
                                                                                        },
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "span",
                                                                                        {
                                                                                          staticClass:
                                                                                            "path1 letterSpacing0",
                                                                                        }
                                                                                      ),
                                                                                      _c(
                                                                                        "span",
                                                                                        {
                                                                                          staticClass:
                                                                                            "path2 letterSpacing0",
                                                                                        }
                                                                                      ),
                                                                                      _c(
                                                                                        "span",
                                                                                        {
                                                                                          staticClass:
                                                                                            "path3 letterSpacing0",
                                                                                        }
                                                                                      ),
                                                                                      _c(
                                                                                        "span",
                                                                                        {
                                                                                          staticClass:
                                                                                            "path4 letterSpacing0",
                                                                                        }
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ]
                                                                          },
                                                                        },
                                                                      ],
                                                                      null,
                                                                      true
                                                                    ),
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-list",
                                                                    {
                                                                      attrs: {
                                                                        dense:
                                                                          "",
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._l(
                                                                        _vm.items,
                                                                        function (
                                                                          listItem
                                                                        ) {
                                                                          return [
                                                                            _vm.showInstanceAction(
                                                                              listItem
                                                                            )
                                                                              ? _c(
                                                                                  "v-list-item",
                                                                                  {
                                                                                    key: listItem.title,
                                                                                    on: {
                                                                                      click:
                                                                                        function (
                                                                                          $event
                                                                                        ) {
                                                                                          return _vm.handleAction(
                                                                                            item.id,
                                                                                            listItem.action,
                                                                                            item.name
                                                                                          )
                                                                                        },
                                                                                    },
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "v-list-item-action",
                                                                                      {
                                                                                        staticClass:
                                                                                          "mr-3",
                                                                                      },
                                                                                      [
                                                                                        _c(
                                                                                          "v-icon",
                                                                                          {
                                                                                            attrs:
                                                                                              {
                                                                                                small:
                                                                                                  "",
                                                                                              },
                                                                                          },
                                                                                          [
                                                                                            _vm._v(
                                                                                              _vm._s(
                                                                                                listItem.icon
                                                                                              )
                                                                                            ),
                                                                                          ]
                                                                                        ),
                                                                                      ],
                                                                                      1
                                                                                    ),
                                                                                    _c(
                                                                                      "v-list-item-content",
                                                                                      [
                                                                                        _c(
                                                                                          "v-list-item-title",
                                                                                          [
                                                                                            _vm._v(
                                                                                              " " +
                                                                                                _vm._s(
                                                                                                  listItem.title
                                                                                                ) +
                                                                                                " "
                                                                                            ),
                                                                                          ]
                                                                                        ),
                                                                                      ],
                                                                                      1
                                                                                    ),
                                                                                  ],
                                                                                  1
                                                                                )
                                                                              : _vm._e(),
                                                                          ]
                                                                        }
                                                                      ),
                                                                    ],
                                                                    2
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _vm._l(
                                                _vm.headersCounter - 1,
                                                function (header) {
                                                  return _c("td", {
                                                    key: header,
                                                    staticStyle: {
                                                      border: "none",
                                                    },
                                                  })
                                                }
                                              ),
                                            ],
                                            2
                                          )
                                        }
                                      )
                                    },
                                  },
                                  {
                                    key: "no-data",
                                    fn: function () {
                                      return [
                                        _c(
                                          "v-row",
                                          {
                                            staticClass: "mx-0 fullSize",
                                            attrs: { justify: "center" },
                                          },
                                          [
                                            _c(
                                              "v-col",
                                              {
                                                attrs: {
                                                  "align-self": "center",
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-row",
                                                  {
                                                    attrs: {
                                                      justify: "center",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "p",
                                                      {
                                                        staticStyle: {
                                                          color: "#d4d4d4",
                                                          "font-size": "16px",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(" Click "),
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            staticClass: "pb-1",
                                                            attrs: {
                                                              color: "primary",
                                                            },
                                                          },
                                                          [_vm._v("add ")]
                                                        ),
                                                        _vm._v(
                                                          " to run an application "
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ]),
                              }),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "text-center custom-table-footer",
                                },
                                [
                                  _c(
                                    "v-row",
                                    {
                                      staticClass: "mx-0",
                                      attrs: {
                                        justify: "space-between",
                                        "justify-sm": "end",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "ml-2 pagination-item-1",
                                        },
                                        [
                                          _vm.$vuetify.breakpoint.smAndUp
                                            ? _c(
                                                "div",
                                                { staticClass: "mr-6" },
                                                [_vm._v(" Rows per page: ")]
                                              )
                                            : _vm._e(),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "footer-items-wrapper",
                                              class: {
                                                "mr-1":
                                                  _vm.$vuetify.breakpoint
                                                    .smAndUp,
                                              },
                                            },
                                            [
                                              _c("v-select", {
                                                staticClass:
                                                  "footer-items-per-page mt-0",
                                                attrs: {
                                                  dense: "",
                                                  "hide-details": "",
                                                  "menu-props": {
                                                    top: true,
                                                    offsetY: true,
                                                  },
                                                  items: [10, 25, 50, 100],
                                                },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "item",
                                                    fn: function ({ item }) {
                                                      return [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "mb-0 char-lim-tabs page-rows-selection",
                                                          },
                                                          [
                                                            item === -1
                                                              ? _c("div", [
                                                                  _vm._v("All"),
                                                                ])
                                                              : _c("div", [
                                                                  _vm._v(
                                                                    _vm._s(item)
                                                                  ),
                                                                ]),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                  {
                                                    key: "selection",
                                                    fn: function ({ item }) {
                                                      return [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "page-rows-selection",
                                                          },
                                                          [
                                                            item === -1
                                                              ? _c("div", [
                                                                  _vm._v("All"),
                                                                ])
                                                              : _c("div", [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        item
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ]),
                                                model: {
                                                  value: _vm.itemsPerPage,
                                                  callback: function ($$v) {
                                                    _vm.itemsPerPage = $$v
                                                  },
                                                  expression: "itemsPerPage",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                      _c("v-pagination", {
                                        staticClass: "pagination",
                                        attrs: {
                                          length: _vm.pageCount,
                                          "total-visible": _vm.$vuetify
                                            .breakpoint.xsOnly
                                            ? 5
                                            : 7,
                                          circle: "",
                                        },
                                        model: {
                                          value: _vm.page,
                                          callback: function ($$v) {
                                            _vm.page = $$v
                                          },
                                          expression: "page",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
              _c(
                "v-dialog",
                {
                  attrs: {
                    transition: "scroll-x-transition",
                    "overlay-color": "grey darken-2",
                    "max-width": "700",
                    "content-class": "overflowY-hidden",
                    persistent: "",
                  },
                  model: {
                    value: _vm.debugDialog,
                    callback: function ($$v) {
                      _vm.debugDialog = $$v
                    },
                    expression: "debugDialog",
                  },
                },
                [
                  _c(
                    "v-card",
                    {
                      staticStyle: {
                        "min-height": "200px",
                        "max-width": "700px",
                      },
                      attrs: { color: "accent" },
                    },
                    [
                      _c(
                        "v-card-title",
                        {
                          staticStyle: {
                            "background-color": "#47bd96",
                            color: "white",
                            "letter-spacing": "0.03rem",
                            height: "40px",
                          },
                          style: _vm.$vuetify.breakpoint.xsOnly
                            ? "text-align: center !important;"
                            : "",
                        },
                        [_vm._v("Debug View ")]
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "max-height": "600px",
                            "overflow-y": "auto",
                          },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "primary more-btn mt-1 mr-1",
                              staticStyle: { right: "10px", top: "45px" },
                              attrs: {
                                icon: "",
                                text: "",
                                dark: "",
                                width: "28",
                                height: "28",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleAction(
                                    _vm.agentDebugging,
                                    _vm.ACTIONS.DEBUG
                                  )
                                },
                              },
                            },
                            [
                              _c(
                                "v-icon",
                                {
                                  staticStyle: { "font-size": "16px" },
                                  attrs: { small: "" },
                                },
                                [_vm._v("fas fa-redo-alt")]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "pl-5 pt-5",
                              staticStyle: { "min-height": "200px" },
                            },
                            [
                              _vm.loadingDebug
                                ? _c(
                                    "v-row",
                                    {
                                      staticClass: "mx-0",
                                      staticStyle: { "min-height": "200px" },
                                      attrs: {
                                        align: "center",
                                        justify: "center",
                                      },
                                    },
                                    [
                                      _c("v-progress-circular", {
                                        attrs: {
                                          size: 20,
                                          width: "2",
                                          color: "primary",
                                          indeterminate: "",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm.debugInfo != null
                                ? _c(
                                    "v-row",
                                    {
                                      staticClass: "mx-0",
                                      staticStyle: { "min-height": "200px" },
                                      attrs: { align: "center" },
                                    },
                                    [
                                      _c(
                                        "pre",
                                        {
                                          staticStyle: {
                                            "font-size": "14px",
                                            width: "700px",
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.debugInfo))]
                                      ),
                                    ]
                                  )
                                : _c(
                                    "div",
                                    [
                                      _c("v-img", {
                                        staticClass: "mt-5 mx-auto text-center",
                                        attrs: {
                                          "max-height": "170",
                                          "max-width": "170",
                                          src: "/img/dynamic-src-images/errors/oops-error.svg",
                                        },
                                      }),
                                      _c(
                                        "p",
                                        {
                                          staticClass: "mb-0 mt-3 text-center",
                                          staticStyle: {
                                            "font-size": "16px",
                                            "overflow-x": "auto",
                                          },
                                        },
                                        [_vm._v(" Something went wrong! ")]
                                      ),
                                    ],
                                    1
                                  ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-card-actions",
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { text: "", color: "primary" },
                              on: {
                                click: function ($event) {
                                  _vm.debugDialog = !_vm.debugDialog
                                },
                              },
                            },
                            [_vm._v("close ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-dialog",
                {
                  attrs: {
                    transition: "scroll-x-transition",
                    "overlay-color": "grey darken-2",
                    "max-width": "480",
                    "content-class": "overflowX-hidden",
                    persistent: "",
                  },
                  model: {
                    value: _vm.dialog,
                    callback: function ($$v) {
                      _vm.dialog = $$v
                    },
                    expression: "dialog",
                  },
                },
                [
                  _c(
                    "v-card",
                    { attrs: { color: "accent" } },
                    [
                      _c(
                        "v-card-title",
                        {
                          staticStyle: {
                            "background-color": "#47bd96",
                            color: "white",
                          },
                          style: _vm.$vuetify.breakpoint.xsOnly
                            ? "text-align: center !important;"
                            : "",
                        },
                        [_vm._v(" Run Application ")]
                      ),
                      _c(
                        "v-container",
                        { staticClass: "pb-0", attrs: { wrap: "", raw: "" } },
                        [
                          _c(
                            "v-layout",
                            { attrs: { row: "", wrap: "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { sm12: "" } },
                                [
                                  _c(
                                    "v-row",
                                    { attrs: { justify: "center" } },
                                    [
                                      _c("v-col", { attrs: { cols: "11" } }, [
                                        _c(
                                          "h3",
                                          {
                                            staticClass: "subtitle-1",
                                            class: {
                                              "primary--text":
                                                !_vm.availableApplications
                                                  .length,
                                            },
                                            staticStyle: {
                                              "text-align": "center",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.availableApplications
                                                    .length
                                                    ? "Select which applications you want to create"
                                                    : "All applications are created"
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-container",
                                { staticClass: "py-0", attrs: { fluid: "" } },
                                [
                                  _c(
                                    "v-row",
                                    {
                                      attrs: {
                                        align: "center",
                                        justify: "center",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "py-0",
                                          attrs: {
                                            cols: "12",
                                            md: "9",
                                            sm: "9",
                                          },
                                        },
                                        [
                                          !_vm.loadingAvailableApps
                                            ? _c("v-select", {
                                                attrs: {
                                                  disabled:
                                                    !_vm.availableApplications
                                                      .length,
                                                  dense: "",
                                                  outlined: "",
                                                  items:
                                                    _vm.availableApplications,
                                                  "menu-props": {
                                                    offsetY: true,
                                                    maxHeight: "250",
                                                  },
                                                  "item-text": "name",
                                                  "item-value": "id",
                                                  label: `Select apps ${
                                                    !_vm.availableApplications
                                                      .length
                                                      ? "(0)"
                                                      : ""
                                                  }`,
                                                  multiple: "",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "prepend-item",
                                                      fn: function () {
                                                        return [
                                                          _c(
                                                            "v-list-item",
                                                            {
                                                              staticStyle: {
                                                                "max-height":
                                                                  "40px",
                                                                "border-bottom":
                                                                  "1px solid #7f7f7f",
                                                              },
                                                              attrs: {
                                                                ripple: "",
                                                              },
                                                              on: {
                                                                click:
                                                                  _vm.selectAllInstances,
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-list-item-content",
                                                                [
                                                                  _c(
                                                                    "v-list-item-title",
                                                                    {
                                                                      class:
                                                                        _vm
                                                                          .selectedApplications
                                                                          .length ===
                                                                        _vm
                                                                          .availableApplications
                                                                          .length
                                                                          ? "primary--text"
                                                                          : _vm
                                                                              .$vuetify
                                                                              .theme
                                                                              .dark
                                                                          ? "white--text"
                                                                          : "black--text",
                                                                      staticStyle:
                                                                        {
                                                                          "font-size":
                                                                            "16px !important",
                                                                          "font-weight":
                                                                            "400",
                                                                        },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Select All "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ]
                                                      },
                                                      proxy: true,
                                                    },
                                                    {
                                                      key: "item",
                                                      fn: function ({ item }) {
                                                        return [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "mb-0 char-lim-tabs",
                                                            },
                                                            [
                                                              _c("div", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item.name
                                                                  )
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                    {
                                                      key: "selection",
                                                      fn: function ({
                                                        item,
                                                        index,
                                                      }) {
                                                        return [
                                                          index === 0
                                                            ? _c("v-chip", [
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      item.name
                                                                    )
                                                                  ),
                                                                ]),
                                                              ])
                                                            : _vm._e(),
                                                          index === 1
                                                            ? _c("span", [
                                                                _vm._v(
                                                                  " (+" +
                                                                    _vm._s(
                                                                      _vm
                                                                        .selectedApplications
                                                                        .length -
                                                                        1
                                                                    ) +
                                                                    " others) "
                                                                ),
                                                              ])
                                                            : _vm._e(),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  false,
                                                  1988232719
                                                ),
                                                model: {
                                                  value:
                                                    _vm.selectedApplications,
                                                  callback: function ($$v) {
                                                    _vm.selectedApplications =
                                                      $$v
                                                  },
                                                  expression:
                                                    "selectedApplications",
                                                },
                                              })
                                            : _c("v-progress-circular", {
                                                attrs: {
                                                  size: 20,
                                                  width: "2",
                                                  color: "primary",
                                                  indeterminate: "",
                                                },
                                              }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    {
                                      staticStyle: {
                                        height: "40px !important",
                                      },
                                      attrs: { justify: "center" },
                                    },
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "pa-0",
                                          attrs: {
                                            cols: "12",
                                            md: "9",
                                            sm: "9",
                                          },
                                        },
                                        [
                                          _c("v-checkbox", {
                                            staticClass:
                                              "smaller-checkbox mt-0 ml-2",
                                            attrs: {
                                              dense: "",
                                              "x-small": "",
                                              label:
                                                "Autostart selected applications",
                                              "on-icon": "fas fa-check-square",
                                              "off-icon": "far fa-check-square",
                                            },
                                            model: {
                                              value: _vm.autoRunApps,
                                              callback: function ($$v) {
                                                _vm.autoRunApps = $$v
                                              },
                                              expression: "autoRunApps",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm.noAppsSelected &&
                                  _vm.selectedApplications.length === 0 &&
                                  _vm.availableApplications.length
                                    ? _c(
                                        "v-row",
                                        { attrs: { justify: "center" } },
                                        [
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "py-0",
                                              attrs: { xs: "7" },
                                            },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticStyle: {
                                                    color: "#ff3232",
                                                    "text-align": "center",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " Please select at least one application. "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-card-actions",
                        [
                          _c("v-spacer"),
                          _c(
                            "v-btn",
                            {
                              attrs: { text: "" },
                              on: {
                                click: function ($event) {
                                  _vm.dialog = false
                                },
                              },
                            },
                            [_vm._v("Cancel")]
                          ),
                          _c(
                            "v-btn",
                            {
                              attrs: { text: "", color: "primary" },
                              on: { click: _vm.createApplication },
                            },
                            [_vm._v("Create ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-fab-transition",
                [
                  !_vm.loading &&
                  _vm.getApplicationInstances.length &&
                  !_vm.appInstancesError.error &&
                  _vm.isAdmin === true
                    ? _c(
                        "v-btn",
                        {
                          style: { bottom: "70px" },
                          attrs: {
                            fab: "",
                            bottom: "",
                            right: "",
                            color: _vm.$vuetify.theme.dark
                              ? "#685AA1"
                              : "primary",
                            dark: "",
                            fixed: "",
                          },
                          on: { click: _vm.showRunApplicationDialog },
                        },
                        [_c("v-icon", [_vm._v("add")])],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }